var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, IconButton, Menu, MenuItem, } from '@mui/material';
import { AccountCircle, Settings, Logout, Menu as MenuIcon, } from '@mui/icons-material';
import { CompanySelector } from '@/components/CompanySelector';
import { useAuth } from '@/contexts/AuthContext';
var Header = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Channel Manager' : _b, onMenuClick = _a.onMenuClick, _c = _a.showMenuButton, showMenuButton = _c === void 0 ? false : _c;
    var _d = React.useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var _e = useAuth(), user = _e.user, logout = _e.logout;
    var handleMenu = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    handleClose();
                    return [4 /*yield*/, logout()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(AppBar, { position: "sticky", className: "shadow-md", children: _jsxs(Toolbar, { className: "flex justify-between", children: [_jsxs(Box, { className: "flex items-center", children: [showMenuButton && (_jsx(IconButton, { color: "inherit", "aria-label": "open drawer", onClick: onMenuClick, className: "mr-3", children: _jsx(MenuIcon, {}) })), _jsx(Typography, { variant: "h6", component: "h1", className: "font-bold text-white", children: title })] }), _jsxs(Box, { className: "flex items-center space-x-4", children: [_jsx(CompanySelector, {}), _jsx(Button, { color: "inherit", startIcon: _jsx(Settings, {}), className: "hidden md:flex", children: "Settings" }), _jsx(IconButton, { size: "large", "aria-label": "account of current user", "aria-controls": "menu-appbar", "aria-haspopup": "true", onClick: handleMenu, color: "inherit", children: _jsx(AccountCircle, {}) }), _jsxs(Menu, { id: "menu-appbar", anchorEl: anchorEl, anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'right',
                            }, keepMounted: true, transformOrigin: {
                                vertical: 'top',
                                horizontal: 'right',
                            }, open: Boolean(anchorEl), onClose: handleClose, children: [_jsxs(Box, { sx: { px: 2, py: 1, borderBottom: '1px solid rgba(0,0,0,0.12)' }, children: [_jsx(Typography, { variant: "subtitle2", sx: { fontWeight: 'bold' }, children: (user === null || user === void 0 ? void 0 : user.first_name) && (user === null || user === void 0 ? void 0 : user.last_name)
                                                ? "".concat(user.first_name, " ").concat(user.last_name)
                                                : user === null || user === void 0 ? void 0 : user.username }), _jsx(Typography, { variant: "caption", color: "text.secondary", children: user === null || user === void 0 ? void 0 : user.email })] }), _jsxs(MenuItem, { onClick: handleClose, children: [_jsx(Settings, { className: "mr-2" }), "Configuraci\u00F3n"] }), _jsxs(MenuItem, { onClick: handleLogout, children: [_jsx(Logout, { className: "mr-2" }), "Cerrar Sesi\u00F3n"] })] })] })] }) }));
};
export default Header;
